window.Sparkle ??= {};
window.Sparkle.Spotlight ??= {};

Sparkle.Spotlight.StatusBar = class StatusBar {
  constructor() {
    this.render = this.render.bind(this);
    this.setMessage = this.setMessage.bind(this);
    this.setShortcuts = this.setShortcuts.bind(this);
    this._buildMessage = this._buildMessage.bind(this);
    this._buildKeyboardShortcuts = this._buildKeyboardShortcuts.bind(this);
    this.el = jQuery('<div class="spotlight-status-bar">');
  }

  render() {
    this.el.html(this._buildMessage(), this._buildKeyboardShortcuts());
    return this;
  }

  // HELPER FUNCTIONS

  setMessage(message) {
    this.message = message;
    return this.render();
  }

  setShortcuts(shortcuts) {
    this.shortcuts = shortcuts;
    return this.render();
  }

  // PRIVATE

  _buildMessage() {
    return jQuery('<div class="message">').text(this.message);
  }

  _buildKeyboardShortcuts() {
    return jQuery('<div class="shortcuts">').text(this.shortcuts);
  }
};
